import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { Image } from 'react-bootstrap';
import { MyCarsButtons } from 'wsm-mycars-buttons';

class SingleImage extends React.Component {
	constructor(props) {
		super(props);
		this.el = document.createElement('div');
		const [container, ..._otherContainers] = document.querySelectorAll(
			'.ddc-vehicle-image-mini'
		);
		this.containerEl = container;
	}

	componentDidMount() {
		if (this.containerEl) {
			this.containerEl.appendChild(this.el);
		}
	}

	componentWillUnmount() {
		if (this.containerEl) {
			this.containerEl.removeChild(this.el);
		}
	}

	render() {
		const { uuid, image, onClick } = this.props;
		const singleImageProps = {
			src: image,
			responsive: true
		};
		if (onClick) {
			singleImageProps.onClick = onClick;
			singleImageProps.role = 'button';
		}
		// Use a portal to render the image into the sidebar
		return ReactDOM.createPortal(
			<div>
				<MyCarsButtons
					uuid={uuid}
					isLink
					showText={false}
					myCarsSaveButtonClasses="position-absolute p-4"
				/>
				<Image {...singleImageProps} />
			</div>,
			this.el
		);
	}
}

SingleImage.propTypes = {
	image: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	uuid: PropTypes.string.isRequired
};

SingleImage.defaultProps = {
	onClick: null
};

export default SingleImage;



// WEBPACK FOOTER //
// ./src/components/SingleImage.jsx